export const IS_CACHE_RESULT = "Is-Cache-Result";
